import { render, staticRenderFns } from "./BilloDetail.vue?vue&type=template&id=5212935a&"
import script from "./BilloDetail.vue?vue&type=script&lang=js&"
export * from "./BilloDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports